import {AssertUtils} from "goingutils";

export default {
    name: "go-search-mixins",
    computed: {},
    props: {
        //筛选条件列表
        searchFieldAry: {
            type: [Array, Object],
            default: () => []
        }
    },
    methods: {
        getSearchItems() {
            var emptyItem={id: "empty",  type: "ro", label: '--查询条件--'};
            //如果传入的是数组 则通过数组进行渲染  如果是对象 则需要进行转换
            if (AssertUtils.isArray(this.searchFieldAry)) {
                let newAry=[emptyItem];
                this.searchFieldAry.forEach(function (item) {
                    if(item.query!==false){
                        newAry.push(item);
                    }
                })
                return newAry;
            } else {
                //如果用户传入的是对象 而且是表格配置信息 则从表格信息里面获取数组作为查询条件
                if (AssertUtils.isNotNull(this.searchFieldAry) && AssertUtils.isArray(this.searchFieldAry["fieldAry"])) {
                    let newAry2=[emptyItem];
                    this.searchFieldAry["fieldAry"].forEach(function (item) {
                        if(item.query!==false){
                            newAry2.push(item);
                        }
                    })
                    return newAry2;
                }

                var items = [emptyItem];
                //如果传入的是domain对象
                for (var prop in this.searchFieldAry) {
                    items.push(this.searchFieldAry[prop]);
                }
                return items;
            }
        }
    },
    mounted() {
    },
    components: {}
};



// WEBPACK FOOTER //
// ./goingsrc/vueCom/ctlVue/mixins/goSearchMixins.js